const SvgLogo = () => (
    <svg
        width="240"
        height="240"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <filter id="dropShadow" x="-10%" y="-0%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="1.7" />
                <feOffset dx="1" dy="1" result="offsetblur" />
                <feFlood floodColor="rgba(0,0,0,0.3)" />
                <feComposite in2="offsetblur" operator="in" />
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <radialGradient id="gradTomato" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: "#FF6347", stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: "#CC4F3A", stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradDodgerBlue" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: "#1E90FF", stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: "#176FCC", stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradLimeGreen" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: "#32CD32", stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: "#28A828", stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradGold" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: "#FFD700", stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: "#CCAC00", stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradHotPink" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: "#FF69B4", stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: "#CC528F", stopOpacity: 1 }} />
            </radialGradient>
            <radialGradient id="gradIndigo" cx="0.3" cy="0.3" r="0.7">
                <stop offset="0%" style={{ stopColor: "#4B0082", stopOpacity: 1 }} />
                <stop offset="100%" style={{ stopColor: "#3A0066", stopOpacity: 1 }} />
            </radialGradient>
        </defs>
        <circle cx="30" cy="30" r="15" fill="url(#gradTomato)" filter="url(#dropShadow)" /> {/* Tomato */}
        <circle cx="50" cy="30" r="15" fill="url(#gradDodgerBlue)" filter="url(#dropShadow)" /> {/* Dodger Blue */}
        <circle cx="70" cy="30" r="15" fill="url(#gradLimeGreen)" filter="url(#dropShadow)" /> {/* Lime Green */}
        <circle cx="40" cy="50" r="15" fill="url(#gradGold)" filter="url(#dropShadow)" /> {/* Gold */}
        <circle cx="60" cy="50" r="15" fill="url(#gradHotPink)" filter="url(#dropShadow)" /> {/* Hot Pink */}
        <circle cx="50" cy="70" r="15" fill="url(#gradIndigo)" filter="url(#dropShadow)" /> {/* Indigo */}
    </svg>
);

const actionBarConfig = {
    appTitle: "Racklet Alpha",
    appLogo: <SvgLogo />, // SVG logo as a React component
    position: "bottom",
    variant: "responsive",
    leftActions: [
        {
            id: "menu",
            type: "menu",
            icon: "Menu",
            tooltip: "Open Menu",
        },
    ],
    rightActions: [
        {
            id: "new_chat",
            type: "icon",
            icon: "Chat",
            tooltip: "New Chat",
        },
    ],
};

export default actionBarConfig;